// Chakra Imports
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Link,
  useColorModeValue,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import AdminNavbarLinks from './AdminNavbarLinks';

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', changeNavbar);

    return () => {
      window.removeEventListener('scroll', changeNavbar);
    };
  });

  const { variant, children, fixed, secondary, brandText, onOpen, ...rest } = props;

  // Hooks must be called unconditionally — compute palette up-front, then assign
  const scrolledShadow = useColorModeValue(
    '0px 4px 20px rgba(0, 0, 0, 0.07), 0px 1px 4px rgba(0, 0, 0, 0.04)',
    '0px 4px 20px rgba(0, 0, 0, 0.30)'
  );
  const scrolledBg = useColorModeValue(
    'rgba(255, 255, 255, 0.88)',
    'rgba(17, 28, 68, 0.88)'
  );
  const scrolledBorder = useColorModeValue('rgba(226,232,240,0.80)', 'rgba(255, 255, 255, 0.10)');
  const scrolledFilter = useColorModeValue('none', 'none');

  let navbarPosition = 'absolute';
  let navbarFilter = 'none';
  let navbarBackdrop = 'none';
  let navbarShadow = 'none';
  let navbarBg = 'none';
  let navbarBorder = 'transparent';
  let secondaryMargin = '0px';
  let paddingX = '15px';
  if (props.fixed === true && scrolled === true) {
    navbarPosition = 'fixed';
    navbarShadow = scrolledShadow;
    navbarBg = scrolledBg;
    navbarBorder = scrolledBorder;
    navbarFilter = scrolledFilter;
    // Activate backdrop blur when sticky — Vercel/Linear navbar feel
    navbarBackdrop = 'blur(16px) saturate(1.8)';
  }
  if (props.secondary) {
    navbarBackdrop = 'none';
    navbarPosition = 'absolute';
    secondaryMargin = '22px';
    paddingX = '30px';
  }
  const changeNavbar = () => {
    if (window.scrollY > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  return (
    <Flex
      position={navbarPosition}
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      filter={navbarFilter}
      backdropFilter={navbarBackdrop}
      borderWidth="1.5px"
      borderStyle="solid"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration="0.22s, 0.22s, 0.22s, 0.22s"
      transitionProperty="box-shadow, background-color, backdrop-filter, border-color"
      transitionTimingFunction="cubic-bezier(0.4,0,0.2,1), cubic-bezier(0.4,0,0.2,1), cubic-bezier(0.4,0,0.2,1), cubic-bezier(0.4,0,0.2,1)"
      alignItems={{ xl: 'center' }}
      borderRadius="16px"
      display="flex"
      minH="75px"
      justifyContent={{ xl: 'center' }}
      lineHeight="25.6px"
      mx="auto"
      mt={secondaryMargin}
      pb="8px"
      left={document.documentElement.dir === 'rtl' ? '16px' : ''}
      right={document.documentElement.dir === 'rtl' ? '' : '16px'}
      px={{
        sm: paddingX,
        md: '24px',
      }}
      ps={{
        xl: '12px',
      }}
      pe={{
        md: '0px',
      }}
      pt="8px"
      top="18px"
      w={{ sm: 'calc(100vw - 32px)', xl: 'calc(100vw - 308px)' }}
    >
      <Flex
        w="100%"
        flexDirection={{
          sm: 'column',
          md: 'row',
        }}
        alignItems={{ xl: 'center' }}
      >
        <Box mb={{ sm: '8px', md: '0px' }}>
          {/* <Breadcrumb>
            <BreadcrumbItem color={mainText}>
              <BreadcrumbLink href="#" color={secondaryText}>
                Pages
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem color={mainText}>
              <BreadcrumbLink href="#" color={mainText}>
                {brandText}
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb> */}
          {/* Here we create navbar brand, based on route name */}
          {/* <Link
            color={mainText}
            href="#"
            bg="inherit"
            borderRadius="inherit"
            fontWeight="bold"
            _hover={{ color: { mainText } }}
            _active={{
              bg: "inherit",
              transform: "none",
              borderColor: "transparent",
            }}
            _focus={{
              boxShadow: "none",
            }}
          >
            {brandText}
          </Link> */}
        </Box>
        <Box ms="auto" w={{ sm: '100%', md: 'unset' }}>
          <AdminNavbarLinks
            onOpen={props.onOpen}
            logoText={props.logoText}
            secondary={props.secondary}
            fixed={props.fixed}
            scrolled={scrolled}
          />
        </Box>
      </Flex>
    </Flex>
  );
}
